import React, { useState } from 'react';
import PropTypes from 'prop-types';

import ExternalLinkWrapper from '../navigation/ExternalLinkWrapper';
import ApiGatewayAuthorizerClient from '../../api/clients/shared/ApiGatewayAuthorizerClient';

const ActivityLink = ({ id, url, content, onClick: onClickHandler }) => {
    const [disabled, setDisabled] = useState(false);

    const isPdfLink = url.startsWith('/storage/');

    const handleClick = async () => {
        if (!disabled) {
            onClickHandler();

            setDisabled(true);

            const pdfWindow = window.open();

            const pdfURL = await ApiGatewayAuthorizerClient.getActivityPdf(url);

            pdfWindow.onload = () => {
                URL.revokeObjectURL(pdfURL);
            };

            pdfWindow.location = pdfURL;

            setDisabled(false);
        }
    };

    if (isPdfLink) {
        return (
            <span
                className={`activity-wrapper ${disabled ? 'disabled' : ''}`}
                data-test-id={id}
                role="link"
                tabIndex="0"
                onClick={handleClick}
            >
                {content}
            </span>
        );
    }

    return (
        <ExternalLinkWrapper
            className="activity-wrapper"
            path={url}
            onClick={onClickHandler}
            content={content}
        />
    );
};

ActivityLink.defaultProps = {
    id: '',
    onClick: () => {},
    content: '',
};

ActivityLink.propTypes = {
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    url: PropTypes.string.isRequired,
    content: PropTypes.node,
    onClick: PropTypes.func,
};

export default ActivityLink;
